// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drawing-pair {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: #0008;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
}

.drawing-pair-cuerpo {
  width: min(1500px, 100%);
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
}

.drawing-pair-barra {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  border-bottom: 1px solid #e3e3e3;
  font-size: 14px;
  font-weight: 600;
  color: #1b1b1b;
}

.drawing-pair-cerrar {
  border-radius: 8px;
  padding: 8px 16px;
  font: inherit;
  font-size: 14px;
  cursor: pointer;
  background: #111;
  border: 1px solid #111;
  color: #fff;
}

.drawing-pair-columnas {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  padding: 12px;
  flex: 1 1;
  min-height: 0;
  background: #f2f2f2;
}

.drawing-pair-lado { margin: 0; min-width: 0; display: flex; flex-direction: column; min-height: 0; }
.drawing-pair-visor { flex: 1 1; width: 100%; border: 1px solid #ddd; background: #fff; }
.drawing-pair-lado figcaption { font-size: 13px; color: #333; margin-bottom: 6px; font-weight: 600; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.drawing-pair-imagen { width: 100%; height: auto; background: #fff; border: 1px solid #ddd; }

.auth-image-vacia {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f2f2f2;
  color: #999;
  min-height: 80px;
}

@media (max-width: 900px) {
  .drawing-pair-columnas { grid-template-columns: 1fr; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Offers/DrawingPairModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,SAAO;EACP,aAAa;EACb,mBAAmB;AACrB;;AAEA,qBAAqB,SAAS,EAAE,YAAY,EAAE,aAAa,EAAE,sBAAsB,EAAE,aAAa,EAAE;AACpG,sBAAsB,SAAO,EAAE,WAAW,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;AACtF,gCAAgC,eAAe,EAAE,WAAW,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACpK,uBAAuB,WAAW,EAAE,YAAY,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;;AAE5F;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB,0BAA0B,EAAE;AACvD","sourcesContent":[".drawing-pair {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  background: #0008;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px 16px;\n}\n\n.drawing-pair-cuerpo {\n  width: min(1500px, 100%);\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.drawing-pair-barra {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 14px;\n  border-bottom: 1px solid #e3e3e3;\n  font-size: 14px;\n  font-weight: 600;\n  color: #1b1b1b;\n}\n\n.drawing-pair-cerrar {\n  border-radius: 8px;\n  padding: 8px 16px;\n  font: inherit;\n  font-size: 14px;\n  cursor: pointer;\n  background: #111;\n  border: 1px solid #111;\n  color: #fff;\n}\n\n.drawing-pair-columnas {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  padding: 12px;\n  flex: 1;\n  min-height: 0;\n  background: #f2f2f2;\n}\n\n.drawing-pair-lado { margin: 0; min-width: 0; display: flex; flex-direction: column; min-height: 0; }\n.drawing-pair-visor { flex: 1; width: 100%; border: 1px solid #ddd; background: #fff; }\n.drawing-pair-lado figcaption { font-size: 13px; color: #333; margin-bottom: 6px; font-weight: 600; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.drawing-pair-imagen { width: 100%; height: auto; background: #fff; border: 1px solid #ddd; }\n\n.auth-image-vacia {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f2f2f2;\n  color: #999;\n  min-height: 80px;\n}\n\n@media (max-width: 900px) {\n  .drawing-pair-columnas { grid-template-columns: 1fr; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
